/**
 * Helper para mapear los códigos internos de nivel de suscripción (como están
 * guardados en MongoDB) a los nombres legibles que se muestran en el frontend.
 *
 * IMPORTANTE — fuente de bugs históricos:
 *   Backend usa "estandar" (sin tilde, sin S inglesa).
 *   UI muestra "Standard".
 *   Por años esa diferencia generó comparaciones rotas — usar SIEMPRE este helper.
 *
 * Ver `/app/memory/NIVELES_SUSCRIPCION.md` para detalles.
 */

export const NIVEL_DB_TO_UI = {
  sin_suscripcion: 'Sin suscripción',
  status_report: 'Status Report',
  estandar: 'Standard',
  estandar_pro: 'Standard Pro',
  premium: 'Premium',
};

export const NIVEL_DB_TO_UI_SHORT = {
  sin_suscripcion: '—',
  status_report: 'Status',
  estandar: 'Std',
  estandar_pro: 'Std Pro',
  premium: 'Premium',
};

export const NIVELES_ACTIVOS_DB = ['estandar', 'estandar_pro', 'premium'];

/** Devuelve el nombre legible (UI) para un nivel guardado en DB. */
export const formatNivelSuscripcion = (nivelDb) => {
  if (!nivelDb) return NIVEL_DB_TO_UI.sin_suscripcion;
  return NIVEL_DB_TO_UI[String(nivelDb).toLowerCase()] || String(nivelDb);
};

/** Versión corta para badges / tablas estrechas. */
export const formatNivelSuscripcionShort = (nivelDb) => {
  if (!nivelDb) return NIVEL_DB_TO_UI_SHORT.sin_suscripcion;
  return NIVEL_DB_TO_UI_SHORT[String(nivelDb).toLowerCase()] || String(nivelDb);
};

/** True si el nivel implica suscripción activa con acceso premium. */
export const esNivelActivo = (nivelDb) => NIVELES_ACTIVOS_DB.includes(String(nivelDb || '').toLowerCase());
